module.exports = __webpack_public_path__ + "static/images/ad.beb725d.jpg";